'use strict'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { Router, Route } from 'react-router-dom'
import { Provider } from 'react-redux'

import TidewaysRoute from './app/route'
import TimeExplorer from './monitor/history/time_explorer'

import history from './app/history'
import store from './app/store'

class DefaultHeader extends React.Component {
    render() {
        return <div />
    }
}

class TimeExplorerHeaderWithAllServices extends React.Component {
    render() {
        return <TimeExplorer allServices />
    }
}

class ServiceEnvironmentHeader extends React.Component {
    render() {
        return <TimeExplorer showGraph={false} allServices />
    }
}

(function(jQuery) {
    jQuery.fn.contentNavigation = function(options) {
        jQuery.extend({}, jQuery.fn.contentNavigation.defaults, options)

        return jQuery(this).each(function() {
            let container = jQuery(this)[0]
            const root = createRoot(container)

            // the app.jquery.js sets this, when the main app is loaded.  When
            // its not, then we are most likely outside application and can
            // show default.
            //
            // This is not true for application settings, for example, but they
            // have their own menu.
            let router = store.getState().tidewaysContext.router
            if (!router) {
                return DefaultHeader
            }

            if (store.getState().tidewaysContext.isProfilingSpace()) {
                return DefaultHeader
            }

            let monitoring =
                (store.getState().tidewaysContext.application && store.getState().tidewaysContext.application.license.monitoring) || false

            let explorerHeader = monitoring ? TimeExplorerHeaderWithAllServices : ServiceEnvironmentHeader

            root.render(
                <Provider store={store}>
                    <Router history={history}>
                        <div>
                            {TidewaysRoute(router, 'XhprofOrganizationBundle.Application.show', explorerHeader)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Snapshot.show', explorerHeader)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.OperationSnapshot.show', explorerHeader)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Transaction.show', explorerHeader)}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.list', ServiceEnvironmentHeader)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.listTracepoints', ServiceEnvironmentHeader)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.listTracesHistory', ServiceEnvironmentHeader)}

                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.errors', ServiceEnvironmentHeader)}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.deprecations', ServiceEnvironmentHeader)}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.nonFatals', ServiceEnvironmentHeader)}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.slowSql', ServiceEnvironmentHeader)}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.release', ServiceEnvironmentHeader)}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.incident', ServiceEnvironmentHeader)}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.observation', ServiceEnvironmentHeader)}

                            <Route path="*" component={DefaultHeader} />
                        </div>
                    </Router>
                </Provider>,
            )
        })
    }
})(jQuery)

window.pluginRegistry.register({ selector: '[data-contentnavigation]', invoke: 'contentNavigation', isReact: true })
